import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useMemo } from 'react';
import { usePreOrder } from '~/hooks/vdp/cta';
import { ListenerEvent, type ListenerEventType } from './constants';

type StartPreOrderMessage = IncomingMessage<ListenerEventType, {}>;

function isStartPreOrderMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is StartPreOrderMessage {
  return message.event === ListenerEvent.StartPreOrder;
}

export default function useStartPreOrderHandler(): MessageHandler<ListenerEventType> {
  const preOrder = usePreOrder();

  return useMemo(
    () =>
      new MessageHandler(isStartPreOrderMessage, (_: StartPreOrderMessage) => {
        void preOrder();
      }),
    [preOrder]
  );
}
